import React from 'react';
import { useABTest } from '../ab-test-context';
export var DisableXPSAB = function DisableXPSAB(_ref) {
  var children = _ref.children;
  var abTest = useABTest();
  if ((abTest === null || abTest === void 0 ? void 0 : abTest.experimentId) === 'xps-hidden') {
    // This experiment is a permanent FE experiment inside aggregator.
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};